import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useLanguage } from '@/i18n/LanguageContext';
import { PetPeek } from '@/components/PetPeek';

export const Faq = () => {
  const { t } = useLanguage();
  return (
    <section id="faq" className="py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto relative">
      <PetPeek type="dog" className="bottom-0 right-4 hidden sm:block" />
      <div className="mb-12 space-y-3">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-orange">FAQ</p>
        <h2 className="font-display text-5xl md:text-6xl uppercase leading-[0.9] tracking-tight text-brand-green">{t.faq.title}</h2>
        <p className="text-base md:text-lg font-medium text-brand-green/80">{t.faq.subtitle}</p>
      </div>

      <Accordion type="single" collapsible className="border-t-2 border-brand-green/15">
        {t.faq.items.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-b-2 border-brand-green/15">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 font-display text-xl md:text-2xl uppercase text-brand-green hover:text-brand-orange hover:no-underline text-left transition-colors">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-base font-medium text-brand-green/80 leading-relaxed pb-6 max-w-2xl">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
